export default () => ({
  requestStatus: null,
  data: {},
  isFetching: false,
});
